module.exports = __webpack_public_path__ + "laptop_image.1c2cc6c5b32c8e808d0bfea46363d691.png";